<div class="confirm-assign-rule evir-font-default" cdkTrapFocus cdkTrapFocusAutoCapture>
    <h3 class="heading-3">Assigned Rule</h3>
    <p>Select from existing rules</p>
    <app-rule-filter
        [companyId]="data"
        (ruleIds)="getRuleId($event)"
        [isMultiSelect]="false"
        context="rule-filter assign-rule"
        cdkFocusInitial
    ></app-rule-filter>
    <div
        mat-dialog-actions
        align="center"
    >
        <app-action-button
            title="Cancel"
            type="outlined-1"
            (buttonClicked)="cancelClick()"
        ></app-action-button>
        <app-action-button
            title="Save"
            (buttonClicked)="confirmAssignRule()"
        ></app-action-button>
    </div>
</div>
